package one.healthium.health_advice.ui.message

import co.touchlab.kermit.Logger
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.filterNotNull
import kotlinx.coroutines.flow.mapLatest
import kotlinx.coroutines.flow.onEach
import one.healthium.domain.user.UserEvent
import one.healthium.events.UserEventsChannel
import one.healthium.health_advice.domain.HealthAdviceInteractor
import one.healthium.ui.common.vm.BaseViewModel
import kotlin.time.Clock

internal class HealthAdviceMessageViewModel(
    private val healthAdviceInteractor: HealthAdviceInteractor,
    userEvents: UserEventsChannel,
) : BaseViewModel() {

    private val refreshFlow = MutableStateFlow(Clock.System.now())

    private val _state = MutableStateFlow(HealthAdviceMessageUiState())
    val state = _state.asStateFlow()

    init {
        refreshFlow
            .mapLatest {
                healthAdviceInteractor.getLatestHealthAdviceMessage()
            }
            .onEach { message ->
                _state.value = _state.value.copy(
                    message = message ?: "",
                )
            }
            .catch { error ->
                Logger.e("Error fetching health advice message", error)
            }
            .launch()

        userEvents.events.events
            .filterNotNull()
            .onEach { event ->
                if (event is UserEvent.HealthLogAdded) {
                    userEvents.events.consume(event)
                    delay(800) // wait sheet to dismiss
                    refreshFlow.emit(Clock.System.now())
                }
            }
            .launch()

    }
}